import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "react-datepicker/dist/react-datepicker.css";
import { HelmetProvider } from 'react-helmet-async';
import LogRocket from 'logrocket';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();

reportWebVitals(({ name, delta, id }) => {
  LogRocket.track(name, {
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    id,
  });
});
